import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, useCallback } from 'react';
import { runtimeConfig } from '../utils/runtimeConfig';
import { validateNetwork } from '../utils/networkUtils';
import { dAppKit } from '../utils/dappKit';
import { NETWORKS } from '../types/commonTypes';
const NetworkContext = createContext(null);
export const NetworkProvider = ({ children }) => {
    // Get default from runtime config, falling back to mainnet
    const [network, setNetworkState] = useState(() => validateNetwork(runtimeConfig.getDefaultNetwork()));
    const setNetwork = useCallback((newNetwork) => {
        // Switch dApp Kit BEFORE our own state. It resolves the signing chain from its OWN
        // $currentNetwork store, so if the two diverge the app's reads move to the new network
        // while transactions keep being signed against the previous chain. Doing it first means a
        // throw leaves both on the old network rather than splitting them. Both start from the
        // same runtime-config value, so they only diverge once someone switches.
        //
        // Synchronous and returns void — switchNetworkCreator just calls $currentNetwork.set() —
        // so there is no promise to handle here.
        dAppKit.switchNetwork(newNetwork);
        setNetworkState(newNetwork);
        console.log(`🔄 Network switched to: ${newNetwork}`);
    }, []);
    const availableNetworks = [...NETWORKS];
    const contextValue = {
        network,
        setNetwork,
        availableNetworks,
    };
    return _jsx(NetworkContext.Provider, { value: contextValue, children: children });
};
export const useNetwork = () => {
    const context = useContext(NetworkContext);
    if (!context) {
        throw new Error('useNetwork must be used within a NetworkProvider');
    }
    return context;
};
// Helper hook to get just the network string (for backward compatibility)
export const useNetworkString = () => {
    const { network } = useNetwork();
    return network;
};
